import { styled } from 'src/styles/stitches.config'

export const StyledPageTitle = styled('div', {
    paddingTop: 350,

    variants: {
        underConstruction: {
            true: {
                paddingTop: 50,
            },
        },
    },
})
